/**
 * Pure H OS · Phase D · P0-2 · Reports mock (types + live view).
 * Backed by MongoDB collection `pureh_reports`.
 *
 * A "report" is a recurring or on-demand executive rollup — Weekly
 * Digest, Monthly P&L, Quarterly Board Brief, Launch Post-Mortem,
 * Vendor Performance, Retention Cohort. Composed FROM the same live
 * collections the rest of Pure H reads.
 */
import { liveArray } from "../services/store";

export type ReportCadence = "weekly" | "monthly" | "quarterly" | "on-launch";

export type Report = {
  id: string;
  key: string;
  title: string;
  cadence: ReportCadence;
  audience: string;
  lastRunRelative: string;
  nextRunRelative: string;
  coverage: string;
  sourceModules: string[];
  body?: string;
  kind?: string;
};

export const REPORTS: Report[] = liveArray<Report>("reports");
